import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Headline from '@components/atoms/headline/headline';
import Image from '@components/atoms/image/image';
import FilterTag from '@components/atoms/filter-tag/filterTag';
import Copy from '@components/atoms/copy/copy';

import { getColor, getSpace, mq } from '@stylesheets/tools';

import ItemWrapper from './ItemWrapper';

const StyledContentItem = styled.div`
  display: flex;
  gap: ${getSpace('s')};

  .content-item__filter {
    display: inline-block;
    margin: 0 ${getSpace('xxs')} ${getSpace('xxs')} 0;
    word-break: break-all;
  }

  .content-item__image {
    display: none;
    position: relative;
    flex-shrink: 0;
    aspect-ratio: 3 / 2;
    width: 190px;
    background: ${getColor('berry')};

    ${mq('m')} {
      display: block;
    }

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
`;

const ContentItem = ({ href, image, categories = [], introCopy, headline }) => {
  const parseIntroCopy = () => {
    const div = document.createElement('div');
    div.innerHTML = introCopy;
    const text = div.textContent || div.innerText || '';

    return text.length > 200 ? `${text.substring(0, 200)}...` : text;
  };

  return (
    <ItemWrapper href={href} target="_blank" rel="noopener noreferrer">
      <StyledContentItem>
        {image && (
          <div className="content-item__image">
            <Image {...image} lazy="default" />
          </div>
        )}

        <div className="content-item__content">
          {categories?.slice(0, 3).map(category => (
            <FilterTag key={category} className="content-item__filter" inverted border>
              {category}
            </FilterTag>
          ))}

          {headline && (
            <Headline tag="h3" subline>
              {headline}
            </Headline>
          )}

          {introCopy && <Copy small>{parseIntroCopy()}</Copy>}
        </div>
      </StyledContentItem>
    </ItemWrapper>
  );
};

ContentItem.propTypes = {
  href: PropTypes.string.isRequired,
  image: PropTypes.shape(),
  categories: PropTypes.arrayOf(PropTypes.string),
  introCopy: PropTypes.string,
  headline: PropTypes.string
};

export default ContentItem;
